/* axios再封装 */
import axios from 'axios'
import userData from '../assets/js/Self-madeLibrary/userData'
import {
  Message,
  Loading
} from 'element-ui'
import store from '../store/index' //vue数据仓库
import router from '../router/index' //vue路由
// import userData from '../assets/js/Self-madeLibrary/userData'
window.loadingInstance = null
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.withCredentials = false

function _loading() {
  loadingInstance = Loading.service({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.2)'
  })
}
let _opts = {}
const pending = []; //把数组内 ，请求停止
let passData = [
  '/company/choose/current/company', //选择当前企业
  '/company/query/user/companys', //查询当前企业
  '/user/webJumpPage',
  '/user/privileges',
  '/message/unread',
  '/approve/toDoListSeparateNum',
  '/user/menu',
  '/user/detail',
];
axios.interceptors.request.use(config => {
  // debugger
  let flag = userData.get_data("forbidden");
  if (flag === '0' && !passData.includes(config.url)) {
    // console.log(config.url)
    config.cancelToken = new axios.CancelToken(function executor(c) {
      c();
      // pending.push(c);
      // console.log(pending)
      // console.log(c)
      // 这个参数 c 就是CancelToken构造函数里面自带的取消请求的函数，这里把该函数当参数用
    })
  }
  // pending.forEach(t=>{
  //   // typeof t == 'function'? t() :'';
  // })
  //显示loading
  if (!loadingInstance || !loadingInstance.close()) {
    if (_opts.lodingState)
      _loading()
  }
  return config
}, error => {
  return Message.error(error.Message);
})

// axios.interceptors.response.use(response => {
//   return response
// }, error => {
//   return Toast({
//     message: error.message
//   });
// })

const ENV = {
  online: ['http://api.jianyitong.com', 'http://materialapi.jianyitong.com', 'http://zhgdApi.jianyitong.com'],
  testline: ['http://api.jianyitongtest.com', 'http://materialapi.jianyitongtest.com',
    'http://zhgdApi.jianyitongtest.com'
  ],
  dev: ['/3', '/4', '/5']
}

const API_ROOT = process.env.NODE_ENV === 'production' ? ENV.online : process.env.NODE_ENV === 'testing' ? ENV
  .testline : ENV.dev

function errorState(response) {
  // 如果http状态码正常，则直接返回数据
  //显示loading
  //  _loading()
  if (loadingInstance) {
    loadingInstance.close()
  }
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    return Message.error(response.data.errorMessage || '网络异常')
    // 如果不需要除了data之外的数据，可以直接 return response.data
  } else {
    return Message.error('请求失败');
  }

}

function successState(res, resolve, opts) {
  //统一判断后端返回的错误码
  // _loading()
  if (opts.streamFile) {
    return res
  }
  if (res.data.code != 1) {
    if (loadingInstance) {
      loadingInstance.close()
    }
    if (res.data.errorCode && res && res.data.errorCode == "ABC001" || res.data.errorCode == "ABC002" || res.data
      .errorCode == "ABC003" || res.data.errorCode == "ABC004") {
      if (res.data.errorCode == 'ABC004') {
        document.getElementById("delogGlobal").style.display = "block"
      } else {
        router.push({
          path: '/entrance/login'
        });
      }
    } else {
      // if(res.data.errorMessage == 'token出错！'){
      //   window.location.href = API_ROOT+'/manager/index.html';
      // }else{
      //   message.error(res.data.errorMessage || '网络异常',2.5)
      //   return false
      // }
      // Message.error(res.data.errorMessage || '网络异常')
      return res
    }
  } else {
    if (loadingInstance) {
      loadingInstance.close()
    }
    return res
  }
}


const httpServer = (opts, data, addressParameter, contentType) => {
  _opts = opts
  // multipart/form-data  文件上传的时候使用的contentType

  // let params = new URLSearchParams()
  // if(fromData){
  //   params = new fromData()
  // }
  // if(JSON.stringify(data) != '{}'){
  //       for (let i in data) {
  //         if (data[i] || data[i] == '0') {
  //           params.append(i, data[i])
  //         }
  //       }
  //       params.append('token',user.get_data('userData').token)
  // }else{
  //   params.append('token',user.get_data('userData').token)
  // }
  store.state.sealData.loading = store.state.sealData.loading + 1
  let _url = ''
  // console.log("opts.urlEnd>>>",opts.urlEnd);
  if (opts.urlEnd && opts.urlEnd != 'void') {
    _url = opts.url + addressParameter + opts.urlEnd
  } else if (opts.urlEnd && opts.urlEnd == 'void') {
    _url = opts.url + addressParameter
  } else {
    _url = opts.url
  }

  let requestPrefix = API_ROOT[0];
  if (opts.doadmin == 'materials') {
    requestPrefix = API_ROOT[1];
  } else if (opts.doadmin == 'zhgdApi') {
    requestPrefix = API_ROOT[2];
  }

  let httpDefaultOpts = { //http默认配置
    method: opts.method,
    // baseURL: opts.baseURL,
    baseURL: requestPrefix,
    url: _url,
    timeout: 30000,
    params: data,
    data: data,
    headers: contentType ? {
      "Content-Type": "application/json"
    } : opts.method == 'get' ? {
      'X-Requested-With': 'XMLHttpRequest',
      "Accept": "application/json",
      "Content-Type": "application/json; charset=UTF-8"
    } : {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
  if (_url == '/project/saveImportInfo') {
    delete httpDefaultOpts.timeout
  }
  if (opts.method == 'get') {
    delete httpDefaultOpts.data
  } else {
    delete httpDefaultOpts.params
  }
  let promise = new Promise(function(resolve, reject) {
    axios(httpDefaultOpts).then(
      (res) => {
        resolve(successState(res, resolve, opts))
        // resolve(res)
      }
    ).catch(
      (response) => {
        reject(errorState(response))
      }
    )

  })
  return promise
}

export default httpServer



// WEBPACK FOOTER //
// ./src/api/index.js